(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:HistoricoplantiosCtrl
   * @description
   * # HistoricoplantiosCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('HistoricoPlantiosCtrl', HistoricoPlantiosCtrl);

  HistoricoPlantiosCtrl.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    'PeriodSelectService',
    'filterFilter',
    'HistoricosService',
    'MessagesService',
    'PlantiosService',
    '$q',
    'RecomendacoesSemeaduraService',
    'MapaService',
    '$http',
    'GoogleMapsService',
    'PeriodosService',
    'DrawPolygonsObjectService',
    '$route',
    '$routeParams',
    'LeafletService',
    'AplicacoesService',
    'TrackingService',
    'Collections',
    '$anchorScroll'
  ];
  /* eslint-disable-next-line max-lines-per-function, max-params */
  function HistoricoPlantiosCtrl($scope, $rootScope, LoadingService, PeriodSelectService, filterFilter,
    HistoricosService, MessagesService, PlantiosService, $q, RecomendacoesSemeaduraService, MapaService, $http,
    GoogleMapsService, PeriodosService, DrawPolygonsObjectService, $route, $routeParams, LeafletService,
    AplicacoesService, TrackingService, Collections, $anchorScroll) {
    let hasPage = true;
    let inProgress = true;
    let requestId = 0;
    let percentualRecomendadoAplicado;
    let activePolygons = [];

    //////////////////////////////////////////
    // Controller data
    $scope.initialized = false;
    $scope.glebas = $rootScope.currentPropriedade.glebas || [];
    $scope.applications = [];
    $scope.plantiosFilters = {};
    $scope.filtroPeriodo = {};
    $scope.loadingAplicacoes = false;
    $scope.pendingRecommendations = [];
    $scope.statusFilter = { integrado: false, erro: false, pendente: false };

    //////////////////////////////////////////
    // Bindable methods
    $scope.initializeVariables = initializeVariables;
    $scope.initialize = initialize;
    $scope.resetPeriodsFilter = resetPeriodsFilter;
    $scope.setValoresComBaseNoHistorico = setValoresComBaseNoHistorico;
    $scope.getApplications = getApplications;
    $scope.openApplicationDetail = openApplicationDetail;
    $scope.getSubCardApplicationId = getSubCardApplicationId;
    $scope.getCardApplicationId = getCardApplicationId;
    $scope.setPositionSubCardPlantio = setPositionSubCardPlantio;
    $scope.setClassificacaoAplicadoRecomendado = setClassificacaoAplicadoRecomendado;
    $scope.openRecommendationDetail = openRecommendationDetail;
    $scope.isOpened = isOpened;
    $scope.getRecommendationDataInicio = getRecommendationDataInicio;
    $scope.getRecommendationDataFim = getRecommendationDataFim;
    $scope.canManage = canManage;
    $scope.showAreaDemarcada = showAreaDemarcada;
    $scope.showRastroMaquina = showRastroMaquina;
    $scope.setFilterAttribute = setFilterAttribute;
    $scope.setPeriodo = setPeriodo;
    $scope.openPeriodsFilter = openPeriodsFilter;
    $scope.toggleStatusFilter = toggleStatusFilter;
    $scope.getStatusFilterLabel = getStatusFilterLabel;
    $scope.getEstadiosCultura = getEstadiosCultura;
    $scope.remover = remover;
    $scope.getRecommendationProducts = getRecommendationProducts;
    $scope.edit = edit;

    //////////////////////////////////////////
    // Function declarations

    function initializeVariables() {
      $scope.plantiosFilters.page = 1;
      hasPage = true;
      inProgress = false;
      requestId += 1;
      $scope.applications = [];
      percentualRecomendadoAplicado = $rootScope.parametros.percentual_recomendado_aplicado ||
        PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
    }

    function initialize() {
      if (!$scope.initialized) {
        $scope.initialized = true;
        $scope.loadingAplicacoes = true;
        $scope.plantiosFilters = {
          tipo: 'plantio'
        };

        $scope.initializeVariables();
        PeriodosService.list().then(function(result) {
          $scope.epocas = result.data;
        }, function(error) {
          console.error('Erro ao listar períodos das culturas', error);
        });

        $scope.resetPeriodsFilter();
        $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
        $scope.setValoresComBaseNoHistorico();

        const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
        if (selectedGleba) {
          $scope.plantiosFilters.gleba = $scope.$root.currentPropriedade.glebas
            .find((gleba) => gleba.id === +selectedGleba);
        }
        $scope.getApplications();
        AplicacoesService.closeOpenRecommendationsModal(closeRecommendations);
      } else {
        showPlanningOnMap();
      }
    }

    function setValoresComBaseNoHistorico() {
      let filteredPeriod;

      if ($routeParams.date || $routeParams.historyDate) {
        filteredPeriod = HistoricosService.getFilteredPeriod();
        $scope.plantiosFilters.dataInicial = filteredPeriod.dataInicial;
        $scope.plantiosFilters.dataFinal = filteredPeriod.dataFinal;
        $scope.period = filteredPeriod.periodo;
      }
      if ($routeParams.activeGleba) {
        $scope.plantiosFilters.gleba = filterFilter($scope.glebas, { id: +$routeParams.activeGleba }, true)[0];
      }
    }

    function getPendingRecommendations() {
      return RecomendacoesSemeaduraService.list({
        status: 'publicado',
        safra: _.find($rootScope.safras, 'current')
      })
        .then(({ data }) => {
          $scope.pendingRecommendations = data;
          showPlanningOnMap();
        });
    }

    function showPlanningOnMap() {
      const { all, byGleba } = prepareRecommendationLegend();
      $scope.$emit('setOutrasLegendas', all);
      $scope.$emit('setCustomGlebaPolygonOptions', byGleba);
    }

    // eslint-disable-next-line max-lines-per-function
    function prepareRecommendationLegend() {
      const byGleba = $scope.pendingRecommendations.reduce((result, { atividade, glebas }) => {
        glebas.forEach(({ id }) => {
          result[id] = result[id] || [];
          result[id].push(atividade);
          result[id] = _.uniqBy(result[id], 'id');
        });
        return result;
      }, {});
      const culturasByGleba = Object.values(byGleba)
        .reduce(function(culturasResult, item) {
          const ids = Collections.sortMapField(item, 'id');
          culturasResult[ids] = {
            descricao: Collections.sortMapField(item, 'descricao'),
            cor: `#${ Collections.mixColors(item, 'cor')}`,
            cursor: 'default'
          };

          return culturasResult;
        }, {});

      for (const gleba in byGleba) {
        byGleba[gleba] = {
          fillColor: `#${Collections.mixColors(byGleba[gleba], 'cor')}`,
          opacity: 1,
          weight: 1,
          color: '#fff',
          fillOpacity: 1
        };
      }

      $rootScope.currentPropriedade.glebas.forEach(({ id }) => {
        if (!byGleba.hasOwnProperty(id)) {
          byGleba[id] = {
            fillColor: '#fff',
            fillOpacity: 0,
            opacity: 1,
            color: '#fff',
            weight: 1
          };
        }
      });

      const all = Object.values(culturasByGleba);
      all.push({
        cor: '#fff',
        descricao: 'Não planejada',
        cursor: 'default'
      });

      return { all, byGleba };
    }

    function closeRecommendations() {
      ($scope.applications || []).forEach(function(application) {
        application.openRecommendation = false;
      });
      $scope.$apply();
    }

    // eslint-disable-next-line max-lines-per-function
    function getApplications() {
      const hasFilterPage = $scope.plantiosFilters && $scope.plantiosFilters.page;
      const currentRequestId = requestId;

      function error() {
        if (currentRequestId === requestId) {
          MessagesService.alert('Não foi possível buscar a lista de plantios.');
        }
      }

      if (hasFilterPage && hasPage && !inProgress) {
        $scope.loadingAplicacoes = true;
        inProgress = true;

        const promises = [
          PlantiosService.list($scope.plantiosFilters),
          getPendingRecommendations()
        ];

        if (!$scope.applications.length) {
          promises.push(PlantiosService.getStatusPlantioGlebas($scope.plantiosFilters));
        }

        /* eslint-disable complexity */
        $q.all(promises).then(function(data) {
          if (currentRequestId !== requestId) {
            return;
          }
          const dados = data[0].data || [];
          hasPage = (((data[0].pages || {}).pagination || {}).next || 0) > $scope.plantiosFilters.page;

          if (dados.length > 0) {
            $scope.plantiosFilters.page++;
            $scope.applications = $scope.applications.concat(dados);
            closeApplicationsAreaVisivel();
            clearMapPolygons();

            if ($scope.applications.length === 1) {
              $scope.openApplicationDetail(null, $scope.applications[0]);
            } else if ($routeParams.activeApplication) {
              const app = $scope.applications.find(function(a) {
                return +a.id === +$routeParams.activeApplication;
              });
              if (app) {
                $scope.openApplicationDetail(null, app);
              } else {
                updateRouteParams();
              }
            }
          }
        })
          .catch(error)
          .finally(function() {
            if (currentRequestId === requestId) {
              inProgress = false;
              $scope.loadingAplicacoes = false;
            }
          });
      }
    }

    function openApplicationDetail(event, plantio) {
      stopPropagation(event);
      preventDefault(event);

      if (!plantio || !plantio.id) {
        return;
      }

      clearMapPolygons();
      closeApplicationsAreaVisivel();
      plantio.openRecommendation = false;
      plantio.classificacao = {};

      if (!plantio.open) {
        updateRouteParams(plantio.id);
        plantio.loading = true;
        plantio.allData = {};
        PlantiosService.get(plantio.id).then(function(data) {
          plantio.allData = data.data || {};
          $anchorScroll($scope.getCardApplicationId(plantio));
        })
          .catch(function() {
            MessagesService.alert('Não foi possível consultar o plantio.');
          })
          .finally(function() {
            plantio.loading = false;
            plantio.open = true;
          });
      } else {
        plantio.open = false;
        updateRouteParams();
      }
    }

    function updateRouteParams(id = null) {
      $route.updateParams({
        activeApplication: id
      });
    }

    function openRecommendationDetailFinish(plantio) {
      plantio.recommendation.gleba = filterFilter(
        plantio.recommendation.glebas,
        { id: plantio.gleba.id },
        true
      )[0];

      plantio.recommendation.cultivares = filterFilter(
        plantio.recommendation.cultivares,
        { gleba_id: plantio.gleba.id },
        true
      );

      plantio.recommendation.area = _.sum(
        filterFilter(
          plantio.recommendation.cultivares,
          { gleba_id: plantio.gleba.id },
          true
        ).map((c) => +c.area)
      );

      plantio.recommendation.adubos = filterFilter(
        plantio.recommendation.adubos,
        { gleba_id: plantio.gleba.id },
        true
      );

      $scope.setClassificacaoAplicadoRecomendado(plantio);
      plantio.loadingRecommendation = false;
    }

    function openRecommendationDetail(event, plantio) {
      stopPropagation(event);
      preventDefault(event);

      if (!plantio || !plantio.id || !plantio.open) {
        return;
      }

      if (!plantio.openRecommendation) {
        plantio.openRecommendation = !plantio.openRecommendation;
        plantio.recommendation = {};
        $scope.setPositionSubCardPlantio(plantio);

        if (((plantio.allData || {}).atributo || {}).recomendacao_id) {
          plantio.loadingRecommendation = true;
          RecomendacoesSemeaduraService.get(plantio.allData.atributo.recomendacao_id).then(function(data) {
            if (data.data) {
              plantio.recommendation = data.data;
            } else {
              plantio.recommendation = {};
            }
            openRecommendationDetailFinish(plantio);
          })
            .catch(function(e) {
              MessagesService.alert('Não foi possível consultar a recomendação.');
              console.error('Erro ao consultar recomendação', e);
              plantio.loadingRecommendation = false;
            });
        }
      } else {
        plantio.openRecommendation = !plantio.openRecommendation;
      }
    }

    function setPositionSubCardPlantio(plantio) {
      const card = $(`#${$scope.getCardApplicationId(plantio)}`);
      const subCard = $(`#${$scope.getSubCardApplicationId(plantio)}`);

      subCard.css({
        'min-height': `${card.height()}px`,
        width: `${card.width()}px`,
        top: `${card.offset().top}px`
      });
    }

    function getSubCardApplicationId(plantio) {
      return `subcard-plantio-${plantio.id}`;
    }

    function getCardApplicationId(plantio) {
      return `plantio-${plantio.id}`;
    }

    function setClassificacaoAplicadoRecomendado(plantio) {
      AplicacoesService.setClassificacaoAplicadoRecomendadoSemeadura(plantio, percentualRecomendadoAplicado);
    }

    function isOpened(plantio) {
      return plantio.open && plantio.openRecommendation;
    }

    function getRecommendationDataInicio(plantio) {
      return plantio.recommendation.cultivares.concat(plantio.recommendation.adubos).sort(function(a, b) {
        return moment(a.data_inicio) - moment(b.data_inicio);
      })[0].data_inicio;
    }

    function getRecommendationDataFim(plantio) {
      return plantio.recommendation.cultivares.concat(plantio.recommendation.adubos).sort(function(a, b) {
        return moment(b.data_fim) - moment(a.data_fim);
      })[0].data_fim;
    }

    function canManage() {
      const { recomendacaoSemeadura } = $rootScope.permissions;

      return recomendacaoSemeadura.canManage && recomendacaoSemeadura.canEditDelete;
    }

    function showAreaDemarcada(plantio) {
      if (!plantio.areaVisivel) {
        plantio.areaVisivel = true;

        if (plantio.allData.has_area_demarcada) {
          plantio.polygons = DrawPolygonsObjectService
            .convertToObject(plantio.allData.area_demarcada || {}, true)
            .polygons;

          // Utilizado weight pois este polígono é montado pelo leafletjs
          // https://leafletjs.com/reference-1.2.0.html#polygon
          plantio.polygons.forEach(({ options }) => {
            options.weight = 7;
            options.strokeWeight = 7;
          });

          activePolygons = activePolygons.concat(plantio.polygons);
          $scope.$emit('addPolygons', plantio.polygons);
          const map = LeafletService.getMap('propriedade-map');
          map.fitBounds(plantio.polygons.map(function(polygon) {
            return polygon.getBounds();
          }));
        }
      } else {
        plantio.areaVisivel = false;
        clearMapPolygons();
      }
    }

    function activeHeatmaps(plantio) {
      const { polylines } = plantio;
      if (!polylines.length) {
        return [];
      }

      $route.updateParams({
        heatmaps: 'pulverizacao'
      });
      $scope.$emit('setActiveHeatmaps', {
        heatmaps: [{ ...plantio, title: 'Aplicação de plantio visível' }],
        mapType: 'aplicacao'
      });
      const start = polylines[0].coordinate;
      const end = polylines[polylines.length - 1].coordinate;
      const startEndMarkers = MapaService.createStartEndMarkers(start, end);
      $scope.$emit('setMarkers', startEndMarkers);
      renderPolylines(polylines);
    }

    function getPolylines(data, plantio) {
      const polylines = MapaService.getLeafletPolylineWithObject({
        pontos: data,
        faixas: plantio.allData.faixas_velocidade
      });
      polylines.forEach((polyline) => {
        polyline.decorator = L.polylineDecorator(polyline, {
          patterns: [
            {
              offset: 20,
              repeat: 50,
              symbol: L.Symbol.arrowHead({
                pixelSize: 7,
                polygon: false,
                pathOptions: {
                  stroke: true,
                  color: polyline.options.color
                }
              })
            }
          ]
        });
      });

      return polylines;
    }

    function showRastroMaquina(plantio) {
      if (!plantio.polylines) {
        $scope.$emit('clearHeatMap');
        $http.get(`${SERVER}v1/aplicacoes/${plantio.id}/tracking`).then(function({ data }) {
          if (data.length > 0) {
            plantio.polylines = getPolylines(data, plantio);
            activeHeatmaps(plantio);
          } else {
            plantio.polylines = [];
          }
        });
      } else {
        activeHeatmaps(plantio);
      }
    }

    function renderPolylines(polylines) {
      $scope.$emit('setPolylines', polylines);
      const map = LeafletService.getMap('propriedade-map');
      map.fitBounds(polylines.map(function(polyline) {
        return polyline.getBounds();
      }));

      polylines.forEach(function(polyline) {
        polyline.bindPopup(createInfoWindow(null, polyline));
      });
    }


    function setFilterAttribute(attribute, object, event) {
      preventDefault(event);
      $scope.initializeVariables();
      $scope.plantiosFilters[attribute] = object;
      if (attribute === 'cultura') {
        $scope.getEstadiosCultura();
      }
      $scope.getApplications();
    }

    function openPeriodsFilter(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.plantiosFilters).then(function() {
        $scope.setPeriodo();
      });
    }

    function toggleStatusFilter(status, event) {
      stopPropagation(event);
      preventDefault(event);
      $scope.statusFilter[status] = !$scope.statusFilter[status];
      $scope.initializeVariables();
      $scope.plantiosFilters.status = buildStatusParam($scope.statusFilter);
      $scope.getApplications();
    }

    function getStatusFilterLabel() {
      const statusLabels = { integrado: 'Integrado', erro: 'Erro', pendente: 'Pendente' };
      const chaves = Object.keys(statusLabels);
      const selecionadas = chaves.filter((chave) => $scope.statusFilter[chave]);

      if (selecionadas.length === 0 || selecionadas.length === chaves.length) {
        return 'Status';
      }
      return selecionadas.map((chave) => statusLabels[chave]).join(', ');
    }

    function buildStatusParam(statusFilter) {
      const statusParaApi = { integrado: 'finalizado', erro: 'erro', pendente: 'pendente' };
      const selecionadas = Object.keys(statusParaApi).filter((chave) => statusFilter[chave]);
      return selecionadas.length ? selecionadas.map((chave) => statusParaApi[chave]).join(',') : null;
    }

    function setPeriodo(periodo, event) {
      preventDefault(event);
      $scope.initializeVariables();
      if (periodo) {
        $scope.plantiosFilters.dataInicial = periodo.dataInicial;
        $scope.plantiosFilters.dataFinal = periodo.dataFinal;
        $scope.period.periodo = periodo.descricao;
      }
      $scope.getApplications();
    }

    function resetPeriodsFilter() {
      $scope.plantiosFilters.dataInicial = null;
      $scope.plantiosFilters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    }

    function getEstadiosCultura() {
      $scope.estadios = [];
      $scope.plantiosFilters.estadio = null;

      if ($scope.plantiosFilters.cultura) {
        $scope.loadingEstadio = true;
        HistoricosService.listEstadios($scope.plantiosFilters).then(function(estadios) {
          $scope.estadios = estadios.data || [];
        }, function() {
          MessagesService.alert('Não foi possível buscar os estádios fenológicos.');
        })
          .finally(function() {
            $scope.loadingEstadio = false;
          });
      }
    }

    function remover(plantio) {
      MessagesService.confirm('Deseja realmente excluir o plantio?').then(function() {
        LoadingService.showLoading();
        PlantiosService.delete(plantio.id).then(function() {
          MessagesService.alert('Plantio excluído com sucesso.');
          $route.reload();
        })
          .catch(function(error) {
            let message = 'Falha ao excluir plantio';
            if (_.get(error.data, 'message')) {
              message = `${message}: ${error.data.message}`;
            }
            MessagesService.alert(message);
            console.error('Falha ao excluir plantio', error);
          })
          .finally(LoadingService.hideLoading);
      });
    }

    function getRecommendationProducts(plantio) {
      return ((plantio.recommendation || {}).cultivares || []).concat(((plantio.recommendation || {}).adubos || []));
    }

    function createInfoWindow(event, polygon) {
      const content = TrackingService.getContentInfoWindow(polygon);
      return `<div class="simple-popup">
                ${content}
              </div>`;
    }

    function edit(application) {
      $scope.$emit('activateSidebar', 'editApplication', application);
    }

    function clearMapPolygons() {
      if (activePolygons.length > 0) {
        $scope.$emit('removePolygons', activePolygons);
        activePolygons = [];
      }
    }

    function closeApplicationsAreaVisivel() {
      $scope.applications.forEach((aplicacao) => {
        if (aplicacao.areaVisivel) {
          aplicacao.areaVisivel = false;
        }
      });
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$on('plantioActivate', $scope.initialize);

    $scope.$on('plantioDeactivate', () => {
      $scope.$emit('setOutrasLegendas', null);
      $scope.$emit('setCustomGlebaPolygonOptions', null);
    });

    $scope.$on('applications_close', function() {
      $scope.applications = [];
    });

    $scope.$on('$destroy', () => {
      clearMapPolygons();
      closeApplicationsAreaVisivel();
    });

    $scope.$on('$routeUpdate', function() {
      if ($scope.plantiosFilters) {
        const { gleba, dataInicial } = $scope.plantiosFilters;
        const { activeGleba, historyDate } = $routeParams;

        const filterGlebaChanged = activeGleba && +activeGleba !== (gleba || {}).id;
        const filterDateChanged = historyDate && historyDate !== dataInicial;

        if (filterGlebaChanged || filterDateChanged) {
          initializeVariables();
          setValoresComBaseNoHistorico();
          $scope.getApplications();
        }
      }

      if ($routeParams.activeApplicationsTab !== 'plantio' && activePolygons.length > 0) {
        clearMapPolygons();
        closeApplicationsAreaVisivel();
      }
    });
  }
}());
